/**
 * Enumération définissant les types de ressources disponibles.
 */
enum TYPE_RESSOURCE {
  PDF = "PDF",
  VIDEO = "VIDEO",
  BD = "BD",
  WEBGL = "WEBGL",
  LINK = "LINK",
}
export default TYPE_RESSOURCE;
